<template>
  <div class="detailBox">
    <div class="detailHead">
      <div @click="handlePrev" class="detailHeadLeft">上一页</div>

      <div @click="$router.go(-1)" class="detailHeadLef">返回网站</div>
      <div class="detailHeadMiddle">
        
        <div class="detailHeadTotal">当前页面{{total}}张  第{{query.page}}页</div>
       
      </div>
      
      <div @click="handleNext" class="detailHeadRight">下一页</div>
    </div>
    <div style="height: 44px"></div>
    <div class="detailContent">

      
      <div v-if="total == 0" class="noData">
        客官莫急，还在助力中~
      </div>

      <div v-if="(total !== 0) && listData.length == 0" class="empty">
        没有更多数据了~
      </div>
      
       <el-row :gutter="10">
        <el-col :key="index" v-for="(item, index) in listData" :xs="12" :md="6"
          ><div class="detailItem">
            <img
              class="detailItemImg"
              :src="(item.USERIMG == 'null' || item.USERIMG == 'NO DATA' || !item.USERIMG) ? t : item.USERIMG"
              alt=""
              srcset=""
            />
            <img
              class="detailItemImg detailItemImg2"
              :src="item.IMG"
              alt=""
              srcset=""/>
            <div class="detailItemBottom">
              <div class="detailItemOrder">第{{index +query.page*10+1-10}}次</div>
              <div class="detailItemOrder">["{{item.name}}"]</div>
              <div class="detailItemOrder">{{item.Time}}</div>
              
            </div>
          </div></el-col
        >
        
      </el-row>
    </div>
    <div style="height: 44px"></div>

    
  <!--  <div class="detailBottom">
      <span @click="handleAll">查看全部</span>
    </div>-->
  </div>
</template>

<script>
import axios from "axios";
import { Loading } from "element-ui";
import t from '../../assets/template.png';

export default {
  data() {
    return {
      total: 0,
      t,
      query: {
        act: "pic",
        id: "sz9zcaANu6OGW5CuklQss3mxbouXqe",
        page: 1,
        m: "daochu",
      },
      listData: [],
    };
  },
  mounted() {
    console.log("route = ", this.$route)
    this.query.id = this.$route.query.id;
    this.getData();
  },
  methods: {
    handlePrev() {
      if(this.query.page <= 1){
        return;
      }
      this.query.page -= 1;
      this.getData();
    },
    handleNext() {
      this.query.page += 1;
      this.getData();
    },
    handleAll() {
      this.query.page = 0;
      this.getData();
    },
    getData() {
      this.loading = Loading.service({ fullscreen: true, text: '数据加载中...' });
      axios
        .get("https://api3.xn--nfvr38cjgq.cn/api.php", {
          params: this.query,
        })
        .then((res) => {
          console.log("res = ", res);
          // if (res.data.data == false) {
          //   Message({
          //     type: "warning",
          //     showClose: true,
          //     message: "未查询到数据！",
          //   });
          //   return;
          // }
  
          this.listData = res.data.data;
          this.total = res.data.total;
          // Message({
          //   type: "success",
          //   showClose: true,
          //   message: "查询成功！",
          // });
          this.loading.close();
        })
        .catch(() => {
           this.loading.close();
        });
    },
    // 查看详情
    handleClick(item) {
      console.log("item = ", item);
      // item.danhao
    }
  },

  destroyed() {},
};
</script>

<style scoped>
@import url("./detail.css");
</style>